<template>
  <div v-if="show" class="luanch-bg">
    <van-overlay :show="show">
      <div class="overlay-bg">
        <img :src="backgroundImg" @click="onDetial" />
        <van-button
          class="time-btn"
          color="rgb(51, 51, 51, 0.2)"
          @click.stop="onCountdown"
          slot="button"
          >{{ getTimeText }}</van-button
        >
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Overlay } from "vant"
import { mapGetters, mapMutations } from "vuex"
import * as LuanchApi from "@/api/luanch"
import { loadSeven } from "../../api/lottery"
export default {
  name: "luanch",
  components: {
    [Overlay.name]: Overlay
  },
  data() {
    return {
      show: false,
      countdown: 0,
      backgroundImg: "",
      url: "",
      interval: null,
      dataInfo: {}
    }
  },
  mounted() {
    this.onLoadAd()
  },
  computed: {
    ...mapGetters(["showLuanch"]),
    getTimeText() {
      if (this.countdown > 0) {
        return this.countdown + " 跳过"
      } else {
        return "0 跳过"
      }
    }
  },
  methods: {
    ...mapMutations(["setShowLuanch"]),
    onCountdown() {
      this.show = false
      this.setShowLuanch(false)
      this.onLoadSeven()
    },
    onDetial() {
      if (this.url && this.url.length > 0) {
        this.show = false
        this.setShowLuanch(false)

        if (this.dataInfo.activityType == 1) {
          location.href = `${this.url}?activityId=${this.dataInfo.id}`
        } else {
          location.href = this.url
        }
      }
    },
    startTimer() {
      this.interval = setInterval(() => {
        this.countdown--
        if (this.countdown < 0) {
          clearInterval(this.interval)
          this.onCountdown()
        }
      }, 1000)
    },
    onLoadAd() {
      LuanchApi.loadAd()
        .then((data) => {
          if (data) {
            this.dataInfo = data
            this.show = true
            this.countdown = data["adSeconds"]
            this.backgroundImg = data["backgroundImg"]
            this.url = data.url || ""
            this.startTimer()
          } else {
            this.show = false
            this.setShowLuanch(false)
            this.onLoadSeven()
          }
        })
        .catch((e) => {
          this.show = false
          this.setShowLuanch(false)
          console.log("luanch.vue message == %O", e.msg || e.message)
          this.onLoadSeven()
        })
    },
    onLoadSeven() {
      loadSeven(0)
        .then((data) => {
          if (data) {
            localStorage.setItem(
              "ignoreCustKey",
              JSON.stringify({
                isBannerJump: false,
                ignore: 0
              })
            )
            this.$router.push({ name: "anniversarycelebration" })
          }
        })
        .catch((e) => {
          console.log("message == %O", e.msg || e.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.luanch-bg {
  width: 100%;
  height: 100%;
  background-color: antiquewhite;
  .van-overlay {
    z-index: 9999;
    .overlay-bg {
      width: 100%;
      height: 100%;
      img {
        object-fit: fill;
        width: 100%;
        height: 100%;
      }
      .time-btn {
        border-width: 0;
        position: fixed;
        top: 15px;
        right: 15px;
        height: 26px;
        border-radius: 13px;
        font-size: 12px;
        color: black;
      }
    }
  }
}
</style>